import R from 'ramda';

import { reducerWrapper } from '../support/utils';
import { LOADING_STATUS } from '../support/constants';

import {
  DATA_INTEGRATIONS,
  DATA_INTEGRATION_SAVE,
  DATA_INTEGRATION_UPDATE,
  DATA_INTEGRATION_DISABLE,
  DATA_INTEGRATION_DELETE,
  OLD_DATA_INTEGRATIONS,
  OLD_DATA_INTEGRATIONS_DISABLE,
  EVENT_INGESTION_SAVE
} from '../actions/DataIntegrationsActions';

var INIT_STATE = {
  loading: false,
  loadingStatus: LOADING_STATUS.INIT,
  error: null,
  data: null,

  /**
   * This is data from DI1. Used here only for disabling
   * Do not modify this except to set enabled: false
   * TODO: Remove this once we have completely migrated to DI2
   * @type {object}
   */
  oldDI: null
};

function getMergedIntegration(state, data) {
  const index = state.data.findIndex(partner => {
    return partner.machine_name === data.machine_name;
  });
  const nextData = state.data.slice();
  nextData[index] = Object.assign({}, nextData[index], {
    enabled: data.enabled,
    integration: data
  });

  return Object.assign({}, state, {
    loading: false,
    loadingStatus: LOADING_STATUS.LOADED,
    data: nextData
  });
}

function Handler(state, action) {
  const { data } = action;

  switch (action.type) {
    case DATA_INTEGRATIONS.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        data
      });
    // Same behavior for all of these
    case DATA_INTEGRATION_SAVE.response:
    case DATA_INTEGRATION_UPDATE.response:
    case DATA_INTEGRATION_DISABLE.response:
    case DATA_INTEGRATION_DELETE.response:
      return getMergedIntegration(state, data);

    case OLD_DATA_INTEGRATIONS.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        oldDI: data
      });
    case OLD_DATA_INTEGRATIONS_DISABLE.response:
      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        oldDI: Object.assign({}, state.oldDI, {
          [data.integration_key]: data
        })
      });
    case EVENT_INGESTION_SAVE.response:
      const newData = state.data.map(blueprint => {
        const provider = blueprint.machine_name.split('_')[1].toUpperCase();
        if (data.provider !== provider) {
          return blueprint;
        }
        return R.assoc('ingestion', data, blueprint);
      });

      return Object.assign({}, state, {
        loading: false,
        loadingStatus: LOADING_STATUS.LOADED,
        data: newData
      });

    default:
      return state;
  }
}

const DataIntegrations = reducerWrapper(INIT_STATE, Handler, {
  request: [
    DATA_INTEGRATIONS,
    DATA_INTEGRATION_SAVE,
    DATA_INTEGRATION_UPDATE,
    DATA_INTEGRATION_DISABLE,
    DATA_INTEGRATION_DELETE,
    OLD_DATA_INTEGRATIONS,
    OLD_DATA_INTEGRATIONS_DISABLE,
    EVENT_INGESTION_SAVE
  ],
  error: [
    DATA_INTEGRATIONS,
    DATA_INTEGRATION_SAVE,
    DATA_INTEGRATION_UPDATE,
    DATA_INTEGRATION_DISABLE,
    DATA_INTEGRATION_DELETE,
    OLD_DATA_INTEGRATIONS,
    OLD_DATA_INTEGRATIONS_DISABLE,
    EVENT_INGESTION_SAVE
  ],
  resetOn: ['APP_CHANGE']
});

export default DataIntegrations;
